import { ref, readonly } from 'vue';

// Set when a developer signed in as another user with a one-time act-as code.
// The API then adds `actor` and `act_as_expires_at` to the login response.
const initial = (() => {
  try { return JSON.parse(localStorage.getItem('actAs') || 'null'); }
  catch { return null; }
})();

const state = ref(initial);

export const actAs = readonly(state);

export function setActAsFromLogin(data) {
  if (data?.actor) {
    state.value = { actor: data.actor, expiresAt: data.act_as_expires_at || null };
    localStorage.setItem('actAs', JSON.stringify(state.value));
  } else {
    clearActAs();
  }
}

export function clearActAs() {
  state.value = null;
  localStorage.removeItem('actAs');
}
